// ABOUTME: A random Auth0 password for a candidate the team creates: nobody is told it, nobody can guess it.
// ABOUTME: Candidates then sign in with an email link, Google or a password reset, never with this.

const LOWER = 'abcdefghijklmnopqrstuvwxyz';
const UPPER = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const DIGITS = '0123456789';
const SYMBOLS = '!@#$%^&*';
const ALL = LOWER + UPPER + DIGITS + SYMBOLS;
const LENGTH = 32;

/** A uniform index below `size`, by rejection, so no character is likelier than another. */
const randomIndex = (size: number): number => {
  const limit = Math.floor(0x100000000 / size) * size;
  const value = new Uint32Array(1);
  do {
    crypto.getRandomValues(value);
  } while (value[0] >= limit);
  return value[0] % size;
};

const pick = (alphabet: string) => alphabet[randomIndex(alphabet.length)];

const generateUnguessablePassword = (): string => {
  // One of each class first, so any Auth0 password policy accepts it.
  const characters = [pick(LOWER), pick(UPPER), pick(DIGITS), pick(SYMBOLS)];
  while (characters.length < LENGTH) characters.push(pick(ALL));
  for (let i = characters.length - 1; i > 0; i -= 1) {
    const j = randomIndex(i + 1);
    [characters[i], characters[j]] = [characters[j], characters[i]];
  }
  return characters.join('');
};

export default generateUnguessablePassword;
